<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{
  rows: any[];
}>();

const selectAll = ref(false);
const selectedRows = defineModel<any[]>('selectedRows', { default: [] });

function onSelectAllRows() {
  !selectAll.value ? (selectedRows.value = []) : (selectedRows.value = props.rows || []);
}
</script>

<template>
  <Checkbox
    v-model="selectAll"
    class="grid-item grid-item-header"
    inputId="allRowSelector"
    name="allRowSelector"
    :binary="true"
    @change="onSelectAllRows"
  />
</template>
